import {
  TRIP_LIST,
  TRIP_DETAILS,
  TRIP_QUERY,
  TRIP_LOADING,
  RESET_TRIP,
} from "./types";

export const initialState = {
  list: null,
  details: null,
  query: {
    page: 1,
    perPage: 10,
    keyword: "",
    filters: [],
  },
  loading: [],
};

const TripReducer = (state: any, action: any) => {
  switch (action.type) {
    case TRIP_LIST:
      return { ...state, list: action.payload };
    case TRIP_DETAILS:
      return { ...state, details: action.payload };
    case TRIP_QUERY:
      return { ...state, query: action.payload };
    case TRIP_LOADING:
      return { ...state, loading: action.payload };
    case RESET_TRIP:
      return initialState;
    default:
      return state;
  }
};

export default TripReducer;
